export default __webpack_public_path__ + "static/media/VAV+naverwarmer.1c00491c.png";